'use strict';

/*
DOCUMENT ME
xform for var names that are transforming things (dealerResults)
*/

define('modules/module.fad',[
  'jquery',
  './module.dealers',
  'txt!./module.fad.hbs',
  'txt!./module.dealers.results.detail.hbs',
  'lib/util/zip',
  'storageUtil',
  'lib/util/map.static',
  'responsive',
], function ($,
  DealersModule,
  txtTemplate,
  txtResultsDetail,
  zip,
  storageUtil,
  mapStatic,
  responsive
) {
  // the following templates are required when extending a DealersModule
  var __tmplResultsDetail = Handlebars.compile(txtResultsDetail);

  var FadModule = DealersModule.extend({
    template: Handlebars.compile(txtTemplate),
    events: function () {
      // add additional events to those found in the DealersModule that we are extending
      return Object.assign({}, DealersModule.prototype.events(), {

      });
    },

    staticData: {
      all: {
        subtextIcon: '/assets/img/module/fad/map.svg'
      },
      en: {
        subtext: 'Toyota Dealerships',
        headline: 'Find a Toyota Dealer',
        copy: {
          '1x1': '<p>Looking to buy a Toyota? Browse Toyota cars for sale, from new car deals to used trucks.</p>',
          '2x1': '<p>Connect with a Toyota dealer to browse new car deals, certified used cars and used trucks for sale.</p>'
        },
        actions: [
          {
            title: 'Enter ZIP Code or City/State',
            geoLocateLabel: 'Find my location',
            searchLabel: 'Search'
          }
        ],
        dataLayerMore: {
          locate: {
            link_text: 'geolocate'
          },
          search: {
            link_text: 'Find a Toyota Dealer'
          }
        }
      },
      es: {
        subtext: 'Concesionarios Toyota',
        headline: 'Busca por código postal',
        copy: {
          '1x1': '<p>¿Quieres un Toyota? Busca vehículos en venta, desde autos nuevos hasta camionetas usadas.</p>',
          '2x1': '<p>Contacta un concesionario Toyota para ver ofertas en autos nuevos y vehículos usados.</p>'
        },
        actions: [
          {
            title: 'Pon ZIP Code, ciudad o estado',
            geoLocateLabel: 'Buscar mi ubicación',
            searchLabel: 'Buscar'
          }
        ],
        dataLayerMore: {
          locate: {
            link_text: 'geolocate'
          },
          search: {
            link_text: 'Find a Toyota Dealer'
          }
        }
      }
    },

    getTemplateContext: function () {
      return $.extend({}, this.staticData.all, this.staticData[this.getCanvas().getLang()], this.getConfig().data);
    },

    // invoked via module.dealers.js onRender;
    localRender: function () {
      var self = this;
      this.buildMap();
      $(window).on('ZIP_CODE_CHANGED', function () {
        self.buildMap();
      });
    },

    // Add any necessary content to the details obj
    addDetailContent: function (detailsObj, currDealerData) {
      var ctasObj = {
        en: {
          ctas: [
            {
              title: 'Visit Dealer Website',
              url: currDealerData.siteUrl,
              key: 'primary',
              target: '_blank',
              km: 'km-dealer-visit_site'
            }
          ],
        },
        es: {
          ctas: [
            {
              title: 'Ver web del concesionario',
              url: currDealerData.siteUrl,
              key: 'primary',
              target: '_blank',
              km: 'km-dealer-visit_site'
            }
          ],
        }
      };

      return Object.assign({}, detailsObj, {
        ctas: ctasObj[this.getCanvas().getLang()].ctas
      });
    },

    // invoked via module.dealers.js drawDetails();
    drawLocal: function (currDealerData) {
      var header = {
        en: {
          titleMore: 'Search:',
          searchTerm: this.searchTerm,
          actions: [
            {
              title: 'Dealer List',
              url: '#',
            }
          ]
        },
        es: {
          titleMore: 'Buscar:',
          searchTerm: this.searchTerm,
          actions: [
            {
              title: 'Concesionarios',
              url: '#',
            }
          ]
        }
      };
      this.drawDetailHeader(header);
      this.$backSideContent.html(__tmplResultsDetail({
        result: currDealerData,
        details: this.addDetailContent(this.details[this.getCanvas().getLang()], currDealerData),
      }));
      this.drawMap(currDealerData);
    },

    // Map on the front of module
    buildMap: function () {
      var self = this;
      var moduleWidth = this.getConfig().width;
      var currentZip = zip.getCookiedDefaultFallback();
      var dimensionMap = {
        '1': '310x198',
        '2': '633x375',
        '3': '956x375',
        'full': '1024x475'
      };
      var mapOptions = {};
      if (storageUtil.isConfirmedZip()) {
        mapOptions = {
          location: currentZip,
          zoom: 11
        };
      } else {
        mapOptions = {
          location: 'USA',
          zoom: 5
        };
      }
      // max width of a static google map img is 2048 (regardless of scale)
      mapOptions.size = responsive() === 'sm' || responsive() === 'md' ? dimensionMap[1] : dimensionMap[moduleWidth];

      mapStatic(mapOptions).then(function (res) {
        self.$el.attr('data-src', res).lazy();
      }).catch(function (err) {
        console.error('mapStatic getMap error: ', err); // eslint-disable-line no-console
      });
    }

  });

  return FadModule;
});

